import Vue from "vue";
import App from "./App.vue";
import "amfe-flexible";
import router from "./router/index.js";
import store from "./store/index.js";
import "@/styles/index.scss";
import {
  Button,
  Form,
  Field,
  Icon,
  Uploader,
  Search,
  Cascader,
  Empty,
  DatetimePicker,
  Toast,
  Popup,
  Tabbar,
  TabbarItem,
  NavBar,
  Grid,
  Picker,
  GridItem,
  Cell,Dialog,
  CellGroup,
  RadioGroup, Radio ,Checkbox, CheckboxGroup,
  Image as VanImage,ImagePreview 
} from "vant";
import "vant/lib/index.css";
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Button);
Vue.use(VanImage);
Vue.use(Form);
Vue.use(Field);
Vue.use(Search);
Vue.use(Toast);
Vue.use(Tabbar);Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(TabbarItem);
Vue.use(Cell);
Vue.use(Uploader);
Vue.use(CellGroup);
Vue.use(Icon);
Vue.use(Empty);
Vue.use(NavBar);
Vue.use(Grid);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(GridItem);
Vue.use(Cascader);
Vue.use(DatetimePicker);
Vue.use(ImagePreview);
Vue.use(Dialog);

Vue.config.productionTip = false;
// 设置默认标题
document.title = "牛羊管理系统";
new Vue({
  router, // 确保引入路由
  store, // 确保引入状态管理
  render: (h) => h(App),
}).$mount("#app");
